// extracted by mini-css-extract-plugin
export default {"wrapper":"CalendarHolidayView_wrapper__mnjKm"};